/* ==========================================================================
   ZWANZE — recently-viewed.js
   Mémorise les derniers produits consultés et les réaffiche.
   Stockage local uniquement : aucune donnée ne quitte le navigateur,
   rien à déclarer côté RGPD, aucune dépendance à une application tierce.
   ========================================================================== */
(function () {
  'use strict';
  const KEY = 'zwanze:recent';
  const MAX = 12;

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || []; }
    catch (error) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
    catch (error) { /* mode privé : on ignore silencieusement */ }
  }

  /* Enregistrement — la fiche produit expose son handle */
  const marker = document.querySelector('[data-recent-handle]');
  if (marker) {
    const handle = marker.dataset.recentHandle;
    const list = read().filter((item) => item !== handle);
    list.unshift(handle);
    write(list);
  }

  /* Affichage */
  class RecentlyViewed extends HTMLElement {
    async connectedCallback() {
      const current = this.dataset.exclude || '';
      const handles = read().filter((handle) => handle !== current).slice(0, Number(this.dataset.count || 6));
      if (handles.length === 0) { this.remove(); return; }

      const query = handles.map((handle) => 'handle:' + handle).join(' OR ');
      const url = this.dataset.url + '?q=' + encodeURIComponent(query) + '&section_id=' + this.dataset.section;

      try {
        const response = await fetch(url);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('[data-recent-grid]');
        const target = this.querySelector('[data-recent-grid]');
        if (grid && target && grid.children.length > 0) {
          target.innerHTML = grid.innerHTML;
          this.removeAttribute('hidden');
        } else {
          this.remove();
        }
      } catch (error) {
        this.remove();
      }
    }
  }
  customElements.define('z-recently-viewed', RecentlyViewed);
})();
